export default __webpack_public_path__ + "6d7ddfbddb4fc4e44b1b2a27fbf7986f.svg";